import React, { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useBranchAuth } from '../context/BranchAuthContext';
import DeskTracker from './DeskTracker';

/**
 * Feb 2026 — BranchDeskTracker
 *
 * Thin adapter that mounts the shared mobile-first DeskTracker page
 * with the branch JWT + `/branch/desk/*` base path. Redirects
 * unauthenticated visitors to the branch login.
 *
 * Wires `onLogout` so the shared page can both (a) auto-sign-out on a
 * 401 from the desk endpoints and (b) drive the manual "Sign Out"
 * header button. Both flows land the user on the desk-tracker login.
 */
const BranchDeskTracker = () => {
  const { deskToken, deskAuthHeaders, deskLogout } = useBranchAuth();
  const navigate = useNavigate();
  const onLogout = useCallback(() => {
    deskLogout();
    navigate('/branch/desk-tracker/login', { replace: true });
  }, [deskLogout, navigate]);

  if (!deskToken) return <Navigate to="/branch/desk-tracker/login" replace />;
  return (
    <DeskTracker
      authHeaders={deskAuthHeaders}
      basePath="/branch"
      backHref="/branch/desk-tracker"
      onLogout={onLogout}
    />
  );
};

export default BranchDeskTracker;
